import React from 'react';

import t from '@jetshop/intl';
import ProductSpecifications from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import { styled } from 'linaria/react';

const Description = styled('article')`
   margin-bottom: 42px;
   color: #707070;
`;

export const SectionHeading = styled('h2')`
   font-family: var(--text-font);
   font-weight: 700;
   font-size: var(--h3);
   margin-bottom: var(--text-size);
`;

export const ProductSection = styled('section')`
   width: 100%;
   padding-bottom: 3rem;
   overflow: hidden;

   ul.payment-options-list {
      font-size: 16px;
      font-weight: 600;
   }
`;

// Filter out custom fields (malldelar) that are used for other things
export const filterCustomFields = product => {
   const fieldsToExclude = ['intelligentDesignCatId', 'hideAddToCart'];
   return product?.customFields?.filter(c => !fieldsToExclude.includes(c.key));
};

const ProductInfo = ({ product }) => {
   const customFields = filterCustomFields(product);

   return (
      <>
         {product.description && (
            <ProductSection>
               <SectionHeading>{t('Product description')}</SectionHeading>
               <Description
                  dangerouslySetInnerHTML={{
                     __html: product.description,
                  }}
               />
            </ProductSection>
         )}
         {customFields.length > 0 && (
            <ProductSection>
               <SectionHeading>{t('Specifications')}</SectionHeading>
               <ProductSpecifications fields={customFields} />
            </ProductSection>
         )}
      </>
   );
};

export default ProductInfo;
